import Add from "../../table/Add";
import ApiService from "../../../services/apiService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { addKhasara,khasaraTitle } from "../../../constants";
import Farmer from "../famer/Farmer";

const AddKhasara = () =>{
    const navigate = useNavigate();
    const[village,setVillage] = useState()
    const[farmerData,setFarmerData] = useState([]);
         
     useEffect(()=>{
         
        const fetchVillage= async ()=>{
             try{
                const response = await ApiService.axiosApi(`/schemevillage`,{
                    method: "GET",
                    params:{
                        pageNumber :0,
                        pageSize:0
                   }
                })
                if(response.success){
                    setVillage(response.data.data)
                }else{
                    console.log(response.message|| "unable to fect village in khasara")
                }
             }catch(error:any){
                console.log(error)
             }
        }
        fetchVillage();
     },[])

     useEffect(()=>{
          
        const getFarmers = async()=>{
             try{
                 
                const response = await ApiService.axiosApi(`/auth/users`,{
                     method:'GET'
                })
                if(response.success){
                    const farmers = response.data.data.filter((user: any) => user.role === 'Farmer');
                     setFarmerData(farmers)
                }else{
                    console.log(response.message||"unable to fetch farmer in khasara")
                }
             }catch(error){
                 console.log(error)
             }
        }

        getFarmers();
    },[])
  

         const handleSubmit = async (data: any) =>{
            try{
                const response = await ApiService.axiosApi(`/khasara`,{

                    method: 'Post',
                    data: {
                      
                        KhasaraNo:data.KhasaraNo,
                        OwnershipDetail:data.OwnershipDetail,
                        Address:data.Address,
                        ContactNumber:data.ContactNumber,
                        SchemeVillageId:data.SchemeVillagesId,
                        FarmerId:data.UserName,
                        Area:data.Area
                    }
                });
                if(response.success){
                    toast.success(response.message || "Chack Instrument Detail Added Successfully")
                    navigate(-1)
                }else{
                    toast.error(response.message || "Failed to add Chack Instrument Detail")
                    console.log()
                }
            }catch(error: any){
                toast.error(error.message || "Failed to add Chack Instrument Deatil")
                console.log(error)
            }
        }
   

    return(
        
        <Add
        title={addKhasara}
        parentTitle={khasaraTitle}
        onSubmit={handleSubmit}
        fields={[
            {
                name: "KhasaraNo",
                label: "Khasara Number",
                type: "text",
                validation: { required: "Khasara Number is required" }
            },
            {
                name : "OwnershipDetail",
                label : "Ownership Detail",
                type : "text",
                validation : "Ownership Detail is required"

            },
            {
                name : "Address",
                label: "Address",
                type : "text",
                validation : "Address is required"
            },
            {
                name : "ContactNumber",
                label : "Contact Number",
                type : "text",
                validation : "Contact Number is required"
            },
           
           
            {
                name : "Area",
                label : "Area",
                type : "text",
                validation : "Area is required"
            },
            {
                name: "Scheme_Village",
                label: "Scheme Village",
                isDropdown:true,
                dropdownData:village,
                dropdownLabel:"scheme_Village",
                idFieldName:"SchemeVillagesId"
             },
             {
                name: "Farmer",
                label: "Farmer",
                isDropdown:true,
                dropdownData:farmerData,
                dropdownLabel:'userName',
                idFieldName:"UserName"
             }

        ]}
        />
    )
}

export default AddKhasara;